module.exports = __webpack_public_path__ + "img/crypto-seed-phrase-storage_B096J16JVJ.a0113844.jpg";